/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_ConfirmInputs */

const cs_chat_attach_confirm = /** @type {(inputs: Chat_Attach_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přiložit`)
};

const en_chat_attach_confirm = /** @type {(inputs: Chat_Attach_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attach`)
};

/**
* | output |
* | --- |
* | "Attach" |
*
* @param {Chat_Attach_ConfirmInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_confirm = /** @type {((inputs?: Chat_Attach_ConfirmInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_ConfirmInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_confirm(inputs)
	return cs_chat_attach_confirm(inputs)
});